import React from "react";
import Environment from "~/common/Environment";
import { ProductDetailPageResult } from "../ProductDetailPageResult";
import { getAndTrimDescription, getRepeatedProductSchemaProperties, getSpecificationProperties, getProductVariationSchema, updateProductToHaveOnlyLargestVariationGroup, getReviewsForProductSchemas } from "./SchemaHelpers";
import { User } from "~/common/Store/models/User";
import { useProductDetailPageData } from "..";
interface Props {
  activeProduct: ProductDetailPageResult;
  user: User;
}
const ProductGroupSchema = ({
  activeProduct,
  user
}: Props) => {
  const {
    link,
    primaryBrand,
    groupingAttributes,
    specificationTable,
    isRequestAQuoteEnabled,
    customerReviews,
    header
  } = activeProduct;
  const {
    productTemplates: allProducts,
    isGoogleView = false
  } = useProductDetailPageData();
  const domain = `https://www.${Environment.domainWithEnvironment}`;
  const imageDomain = Environment.subdomain ? `https://www.${Environment.domainWithEnvironment}` : `https://cdnimg.webstaurantstore.com`;
  if (isRequestAQuoteEnabled) {
    return null;
  }
  const hasVirtualGroupVariantSchema = allProducts.filter(product => !product.groupingAttributes?.isGroupMaster).map(product => {
    return {
      ...getRepeatedProductSchemaProperties(domain, imageDomain, product, user, isGoogleView && !user.registered),
      sku: product.itemNumber.toLocaleUpperCase()
    };
  });
  const newActiveProduct = updateProductToHaveOnlyLargestVariationGroup(activeProduct);
  const hasVariantSchema = newActiveProduct.variationMembership?.variationGroups?.length > 0 ? getProductVariationSchema(newActiveProduct, domain, imageDomain, user, isGoogleView) : hasVirtualGroupVariantSchema;
  const schemaProductGroup = {
    "@context": "https://schema.org",
    "@type": "ProductGroup",
    name: newActiveProduct.header,
    description: getAndTrimDescription(activeProduct),
    url: domain + link,
    brand: {
      "@type": "Brand",
      name: primaryBrand?.name || ""
    },
    productGroupId: newActiveProduct.variationMembership?.variationGroups[0]?.id?.toString().toLocaleUpperCase() ?? groupingAttributes?.virtualGroupItemNumber?.toLocaleUpperCase(),
    ...getSpecificationProperties(specificationTable),
    hasVariant: hasVariantSchema,
    ...getReviewsForProductSchemas(customerReviews, header)
  };
  return <script type="application/ld+json" suppressHydrationWarning dangerouslySetInnerHTML={{
    __html: JSON.stringify(schemaProductGroup)
  }} data-sentry-component="ProductGroupSchema" data-sentry-source-file="ProductGroupSchema.tsx" />;
};
export default ProductGroupSchema;